var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoldova(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2174 1.19072C15.6397 0.427875 13.8698 0 12 0C10.1302 0 8.36025 0.427875 6.78262 1.19072L5.73914 12L6.78262 22.8093C8.36025 23.5721 10.1302 24 12 24C13.8698 24 15.6397 23.5721 17.2174 22.8093L18.2609 12L17.2174 1.19072Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78263 1.19113C2.76872 3.13208 0 7.24251 0 12C0 16.7575 2.76872 20.8679 6.78263 22.8088V1.19113Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2174 1.19113V22.8088C21.2313 20.8679 24 16.7575 24 12C24 7.24251 21.2313 3.13208 17.2174 1.19113Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1739 9.44152H13.3043C13.3043 8.72115 12.7204 8.13718 12 8.13718C11.2796 8.13718 10.6957 8.72115 10.6957 9.44152H7.82611C7.82611 10.1508 8.44397 10.7257 9.15314 10.7257H9.11039C9.11039 11.435 9.68536 12.01 10.3947 12.01C10.3947 12.638 10.8457 13.1598 11.4414 13.2714L10.4294 15.5562C10.9143 15.7533 11.4443 15.8628 12 15.8628C12.5557 15.8628 13.0857 15.7533 13.5706 15.5562L12.5586 13.2714C13.1543 13.1598 13.6053 12.638 13.6053 12.01C14.3146 12.01 14.8896 11.435 14.8896 10.7257H14.8468C15.5561 10.7257 16.1739 10.1507 16.1739 9.44152Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.2174L10.3044 12V13.5652L12 14.6087L13.6957 13.5652V12L12 11.2174Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3044 10.4348H13.6957V12H10.3044V10.4348Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoldova);
export default __webpack_public_path__ + "static/media/moldova.02f8424637e781b5c883b3d39eb7be8e.svg";
export { ForwardRef as ReactComponent };